import React, {
  FC,
  useState
} from 'react';
import {
  Box,
  Container,
  Divider,
  Grid,
  Link,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
  Button
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import { EnSocialMediaType } from 'src/api/dto/socialmedia/enSocialMediaType';
import KumaoATkumao from './emailaddress/KumaoATkumao';
import MinusIcon from '../icons/Minus';
import Logo from './Logo';
import SocialMediaIcons from './widgets/social/SocialMediaIcons';

interface IContactKumaoATkumao {}

const sections = [
  {
    title: 'Los gehts!',
    links: [
      {
        title: 'Anmelden',
        href: '/login',
        target: '_self'
      },
      {
        title: 'Jetzt mitmachen',
        href: '/register',
        target: '_self'
      },
      {
        title: 'Preise',
        href: '/pricing',
        target: '_self'
      },
      {
        title: 'Hilfe',
        href: '/help',
        target: '_self'
      }
    ]
  },
  {
    title: 'Infos & Medien',
    links: [
      {
        title: 'Geschäftsbedingungen (AGB)',
        href: '/terms-conditions',
        target: '_self'
      },
      {
        title: 'Impressum',
        href: '/imprint',
        target: '_self'
      },
      {
        title: 'Datenschutz',
        href: '/dataprivacy',
        target: '_self'
      },
      {
        title: 'Medien und Werbung',
        href: '/media',
        target: '_self'
      }
    ]
  },
  {
    title: 'Social',
    links: [
      {
        title: 'Facebook',
        href: 'https://www.facebook.com/Kumao-104937725591679',
        target: '_blank',
        icon: EnSocialMediaType.Facebook
      },
      {
        title: 'Instagram',
        href: 'https://www.instagram.com/kumao_at/',
        target: '_blank',
        icon: EnSocialMediaType.Instagram
      },
      {
        title: 'Youtube',
        href: 'https://www.youtube.com/@kumao_at',
        target: '_blank',
        icon: EnSocialMediaType.Youtube
      },
      {
        title: 'LinkedIn',
        href: 'https://at.linkedin.com/company/kumao-at',
        target: '_blank',
        icon: EnSocialMediaType.LinkedIn
      }
    ]
  }
];

const Footer: FC<IContactKumaoATkumao> = () => {
  const [showingEmail, setShowingEmail] = useState(false);

  const email = showingEmail ? (
    <KumaoATkumao />
  ) : (
    <Button
      onClick={() => setShowingEmail(true)}
      color="secondary"
      size="small"
      variant="contained"
    >
      Kontakt E-Mail
    </Button>
  );

  return (
    <Box
      sx={{
        backgroundColor: '#F5F5F7', // 'background.default',
        pb: 6,
        pt: {
          md: 10,
          xs: 2
        },
        mt: 5
      }}
    >
      <Container maxWidth="lg">
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            md={3}
            sm={4}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              order: {
                md: 1,
                xs: 4
              }
            }}
            xs={12}
          >
            <Logo />
            <Box sx={{ mt: 1 }}>
              <Typography
                color="textSecondary"
                variant="caption"
              >
                <React.Suspense fallback={<div>loading...</div>}>
                  <Box
                    sx={{
                      ml: 3
                    }}
                  >
                    {email}
                  </Box>
                </React.Suspense>
              </Typography>
            </Box>
          </Grid>
          {sections.map((section, index) => (
            <Grid
              item
              key={section.title}
              md={3}
              sm={4}
              sx={{
                order: {
                  md: index + 2,
                  xs: index + 1
                }
              }}
              xs={12}
            >
              <Typography
                color="textSecondary"
                variant="overline"
              >
                {section.title}
              </Typography>
              <List disablePadding>
                {section.links.map((link) => (
                  <ListItem
                    disableGutters
                    key={link.title}
                    sx={{
                      pb: 0,
                      pt: 1
                    }}
                  >
                    <ListItemAvatar
                      sx={{
                        alignItems: 'center',
                        display: 'flex',
                        minWidth: 0,
                        mr: 0.5
                      }}
                    >
                      {link.icon && (<SocialMediaIcons icon={link.icon} />)}
                      {!link.icon && (<MinusIcon color="primary" />)}
                    </ListItemAvatar>
                    <ListItemText
                      primary={(
                        <Link
                          href={link.href}
                          color="textPrimary"
                          variant="subtitle2"
                          target={link.target}
                        >
                          {link.title}
                        </Link>
                      )}
                    />
                  </ListItem>
                ))}
              </List>
            </Grid>
          ))}
        </Grid>
        <Divider
          sx={{
            borderColor: (theme) => alpha(theme.palette.primary.contrastText, 0.12),
            my: 6
          }}
        />
        <Typography
          color="textSecondary"
          variant="caption"
        >
          All Rights Reserved by Kumao GmbH.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
